exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.month-year-at-current-address{max-width:192px}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/checkout/CreditAssessmentStep2/CaAddressDetails.scss
 ** module id = 1227
 ** module chunks = 0
 **/